module.exports = __webpack_public_path__ + "img/Landing_Page_step_03b.b9652476.jpg";